import { useEffect } from 'react';
import {
  ActivityIndicator,
  StyleSheet,
  Text,
  View,
} from 'react-native';
import { useRouter } from 'expo-router';
import { useTranslation } from 'react-i18next';

import { useAppTheme } from '@/theme/app-theme';

export default function AppleOAuthCallback() {
  const router = useRouter();
  const { colors } = useAppTheme();
  const { t } = useTranslation();

  useEffect(() => {
    const timeout = setTimeout(() => {
      router.replace('/(auth)/welcome');
    }, 3000);

    return () => clearTimeout(timeout);
  }, [router]);

  return (
    <View
      style={[
        styles.screen,
        { backgroundColor: colors.background },
      ]}>
      <ActivityIndicator color={colors.primary} />
      <Text style={[styles.text, { color: colors.textSecondary }]}>
        {t('auth.welcome.finishingApple')}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  screen: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
  },
  text: {
    fontSize: 15,
    fontWeight: '600',
  },
});

